   const menuDrawer = document.querySelector('[data-breakpoint="tablet"]');
      const body = document.body;

      // Get the 'details' element that controls the menu opening/closing
      const details = document.querySelector('#Details-menu-drawer-container');

      // Event listener for when the menu is opened or closed
      details.addEventListener('toggle', function () {
        // Check if the menu is open or closed
        if (details.open) {
          // Add class to body to prevent scrolling
          body.classList.add('menu-open');
        } else {
          // Remove class to allow scrolling again
          body.classList.remove('menu-open');
        }
      });